<template>
  <router-view v-slot="{ Component }" v-if="isKeep">
    <keep-alive>
      <component :is="Component"/>
    </keep-alive>
  </router-view>
  <router-view v-else/>
</template>

<script>
import {useRouter} from "vue-router";
import {ref, watch} from "vue";

export default {
  name: "RouteView",
  setup() {
    const router = useRouter();
    const isKeep = ref(false);

    watch(
        () => router.currentRoute.value,
        () => {
          const routeKeepAlive = router.currentRoute.value.meta.keepAlive;
          isKeep.value = routeKeepAlive?routeKeepAlive:false;
          console.log("set page"+router.currentRoute.value.path+" keep alive:", isKeep.value)
        },
        {
          immediate: true,
        },
    );
    return {
      isKeep,
    };
  },
}
</script>

<style scoped>

</style>